<template>
  <div class="container flex" style="margin-bottom: 20px;">
    <left></left>
    <div class="live flex1" style="margin-left: 20px;">
    	<div class="title flex algin-center">
    		错题收藏
         - <span class="flex flex1">{{tag==1?'错题':'收藏'}}</span>

    		<span class="prev font14" @click="handlePrev()" v-if="cindex>0" ><img src="../assets/img/prev.png" style="margin-right: 5px;">上一题</span>
    		<span class="next font14" @click="handleNext()" v-if="cindex<list.length-1">下一题<img src="../assets/img/next.png" style="margin-left: 5px;"></span>
    	</div>
    	<div class="flex padding-15">
    		<span class="questiontype flex1">
          <template v-if="examObj.questionStatus==1">
          【单项选择题】
        </template>
        <template v-if="examObj.questionStatus==2">
          【多项选择题】
        </template>
        <template v-if="examObj.questionStatus==3">
          【计算题】
        </template>
        <template v-if="examObj.questionStatus==4">
          【综合题】
        </template></span>
    		<span style="color: #4fa7ff;">{{cindex+1}}</span> / {{list.length}}
    	</div>
    	<div class="line">

    	</div>
    	<div class="" style="padding: 20px 30px;">
    		<div class="flex">
    			<span class="flex1"><span v-html="examObj.questionTitle"></span></span>
    			<span style="color: #4fa7ff;cursor: pointer;" @click="showtops=true;">移除</span>
    		</div>
    		<template  v-if="examObj.questionStatus==1">
    		  <div class="questionlist" v-for="item,index in examObj.optionList">
    		  	<span class="letters" :class="{'done':childIndex==0 ||item.selected}" @click="handleChooseThis(0)" v-if="index==0">A</span>
    		    <span class="letters" :class="{'done':childIndex==1 ||item.selected}" @click="handleChooseThis(1)"  v-if="index==1">B</span>
    		    <span class="letters" :class="{'done':childIndex==2 ||item.selected}" @click="handleChooseThis(2)"  v-if="index==2">C</span>
    		    <span class="letters" :class="{'done':childIndex==3 ||item.selected}" @click="handleChooseThis(3)" v-if="index==3">D</span>
    		    <span class="letters" :class="{'done':childIndex==4 ||item.selected}" @click="handleChooseThis(4)"  v-if="index==4">E</span>
    		    <span class="letters" :class="{'done':childIndex==5 ||item.selected}" @click="handleChooseThis(5)"  v-if="index==5">F</span>
    		    <span v-html="item.optionTitle"></span>
    		  </div>
    		</template>
        <template  v-if="examObj.questionStatus==2">
          <div class="questionlist" v-for="item,index in examObj.optionList">
          	<span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(0)"  v-if="index==0">A</span>
            <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(1)"  v-if="index==1">B</span>
            <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(2)"  v-if="index==2">C</span>
            <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(3)"  v-if="index==3">D</span>
            <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(4)"  v-if="index==4">E</span>
            <span class="letters" :class="{'done':moreList[index] ||item.selected}" @click="handleChooseMore(5)"  v-if="index==5">F</span>
            <span v-html="item.optionTitle"></span>
          </div>
        </template>

    	</div>
    	<div class="line">

    	</div>
    	<template v-if="!isshow">
    	  <div class="viewanswer" style="margin-left: 30px;">
    	  	<span class="btn" @click="handleView()">查看答案</span>
    	  </div>
    	</template>
    	<template v-else>
    	  <div class="viewanswer" style="position: relative;padding: 0 30px;">
    	  	<div style="color: #4fa7ff;margin-top: 20px;">答案解析</div>
    	  	<div class="" style="margin-top: 20px;margin-left: 15px;">
    	  		我的答案：<span style="font-weight: bold;margin-left: 15px;">{{myAnswer?myAnswer:'未答'}}</span>
    	  	</div>
    	  	<div class="" style="margin-top: 20px;margin-left: 15px;">
    	  		参考答案：<span style="color: #5cb85c;">{{rightAnswer}}</span>
    	  	</div>
    	  	<div class="flex" style="margin-top: 20px;margin-left: 15px;">
    	  		<span style="width: 90px;">参考解析：</span><span style="font-size: 14px;color: #999999;" v-html="examObj.questionAnalysis"></span>
    	  	</div>
    	  	<img src="../assets/img/pcright.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==1" >
    	  	<img src="../assets/img/pcerror.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==0" >
    	  </div>
    	</template>

    </div>
    <removetips v-if="showtops" @handleCloseTips="showtops=false;" @handleRemove="handleRemove"></removetips>
  </div>
</template>

<script>
  document.onkeydown=function(e){


    if(e.code=='F5'){
      e.preventDefault()
    }

  }
  import left from './left.vue'
  import removetips from './removetips.vue'
  export default {
    name: 'Footer',
    components:{
      left,
      removetips
    },
    data () {
      return {
          data:'',
          pageNo:1,
          pageSize:10,
          list:[],
          chapterId:this.$route.query.chapterId,
          type:this.$route.query.type,
          tag:this.$route.query.tag,
          cindex:-1,
          examObj:{},
          childIndex:-1,//单选索引
          isshow:false,
          myAnswer:'',
          rightAnswer:'',
          moreList:[],
          showtops:false
      }
    },
    methods:{
      handleRemove(){
        let data=new FormData();
            data.append('collQuestionId',this.examObj.collQuestionId);
            data.append('errorQuestionId',this.examObj.errorQuestionId);
            let url=''
            if(this.tag==1){
            						url=this.$common.testPaper_newRemoveErrorQuestion;
            					}
            					else {
            						url=this.$common.testPaper_newRemoveCollQuestion;
            					}
        this.$axios.post(url,data).then((res)=>{
              if(res.data.code==1){

                this.showtops=false;
                this.list.splice(this.cindex,1);
                if(this.list.length==0){
                  this.$router.push('/')
                }
                else{
                  if(this.index==this.list.length){
                  												 this.cindex--
                  											 }
                  										//	 return;
                  											 this.examObj=this.list[this.cindex]
                }
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleChooseThis(index){  //单选
          if(this.isshow){
            return;
          }
          this.childIndex=index;
          this.examObj.optionList.forEach((item,cindex)=>{
            if(cindex==index){
              item.selected=true;
            }
            else {
              item.selected=false;
            }
          })
      },
      handleChooseMore(index){ //多选
        if(this.isshow){
          return;
        }
        this.$forceUpdate()
        this.moreList[index]=!this.moreList[index];

      },
      getAnswer(){  //获取答案
        var lettersList=['A','B','C','D','E','F'];
        var myAnswer=[];
        var rightAnswer=[];
        this.examObj.optionList.forEach((item,index)=>{

            if(item.selected){

              myAnswer.push(lettersList[index])
            }
            if(item.optionAnswerStatus){

              rightAnswer.push(lettersList[index])
            }
        })

        this.myAnswer=myAnswer.join();
        this.rightAnswer=rightAnswer.join();
      },
      handleView(){  //查看答案
        this.isshow=true;

        if(this.examObj.questionStatus==2){
          var list=this.moreList.filter((item)=>{
               return item
          })
          // if(list.length==0){

          //   alert('请选择答案')
          //   return;
          // }
          console.log(this.moreList)
          this.moreList.forEach((item,index)=>{
              if(item){
                  this.examObj.optionList[index].selected=true;
              }
          })
          var answerStatus=this.examObj.optionList.every((item)=>{return item.optionAnswerStatus==Boolean(item.selected)});
          this.examObj.answerStatus=answerStatus?1:0;
        }
        else {
          var answerStatus=this.examObj.optionList.every((item)=>{return item.optionAnswerStatus==Boolean(item.selected)});
          this.examObj.answerStatus=answerStatus?1:0;
        }
        this.getAnswer();
      },
      handlePrev(){
        this.cindex--;
        this.isshow=false;
      },
      handleNext(){
        this.cindex++;
        this.isshow=false;
      },
      getData(){
        let url='';
        if(this.type==1 && this.tag==1){

          url=this.$common.testPaper_sundryTestErrorQuestionList
        }
        if(this.type==1 && this.tag==2){
            url=this.$common.testPaper_newSundryCollQuestionList
        }
        if(this.type==2 && this.tag==1){

          url=this.$common.testPaper_sundryErrorQuestionList;
        }
        if(this.type==2 && this.tag==2){

              url=this.$common.testPaper_newSundryCollQuestionList
        }
        this.$axios.get(url+'?chapterId='+this.chapterId ).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data;
                  this.cindex=0
              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created(){
      this.getData();
    },
    watch:{
      cindex(val){
        this.examObj=this.list[val];
        console.log(this.examObj)
        console.log(val)
        this.childIndex=-1;
        this.moreList=this.examObj.optionList.map(()=>{
          return false
        })
      }
    }
  }
</script>

<style scoped="">
  .prev,.next {
  	width: 100px;
  	height: 40px;
  	line-height: 40px;
  	line-height: 40px;
  	background-color: #fff;
  	text-align: center;
  	margin-left: 10px;
    cursor: pointer;
  }
  .live {
  	min-height: 80vh;
  }
  .line {
  	height: 1px;
  	background-color: #ccc;
  }
  .questionlist {
  	margin-top: 20px;
  }
  .letters {
  	width: 30px;
  	height: 30px;
  	border: 1px solid #999999;
  	display: inline-block;
  	text-align: center;
  	line-height: 30px;
  	margin-right: 15px;
  	border-radius: 4px;
    cursor: pointer;
  }
  .done {
      border-color: #4fa7ff;
  }
  .viewanswer .btn {
  	width: 130px;
  	height: 50px;
  	line-height: 50px;
  	text-align: center;
  	color: #fff;
  	background-color: #4fa7ff;
  	display: inline-block;
  	margin-top: 15px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/dotest.vue